export const exchanges: string[] = [
    'AMEX',
    'AMS',
    'AQS',
    'ASX',
    'ATH',
    'BER',
    'BME',
    'BRU',
    'BSE',
    'BUD',
    'BUE',
    'BVC',
    'CBOE',
    'CNQ',
    'CPH',
    'DFM',
    'DOH',
    'DUS',
    'DXE',
    'EGX',
    'EURONEXT',
    'HAM',
    'HEL',
    'HKSE',
    'HOSE',
    'ICE',
    'IOB',
    'IST',
    'JKT',
    'JNB',
    'JPX',
    'KLS',
    'KOE',
    'KSC',
    'KUW',
    'LSE',
    'MCX',
    'MEX',
    'MIL',
    'MUN',
    'NASDAQ',
    'NEO',
    'NSE',
    'NYSE',
    'NZE',
    'OEM',
    'OQB',
    'OSL',
    'OTC',
    'PNK',
    'PRA',
    'RIS',
    'SAO',
    'SAU',
    'SES',
    'SET',
    'SGO',
    'SHH',
    'SHZ',
    'SIX',
    'STO',
    'STU',
    'TAI',
    'TAL',
    'TLV',
    'TSX',
    'TSXV',
    'TWO',
    'VIE',
    'WSE',
    'XETRA'
];

export const countryCodes: string[] = [
    'AE',
    'AI',
    'AR',
    'AT',
    'AU',
    'AZ',
    'BB',
    'BD',
    'BE',
    'BG',
    'BH',
    'BM',
    'BR',
    'BS',
    'BW',
    'CA',
    'CH',
    'CI',
    'CK',
    'CL',
    'CN',
    'CO',
    'CR',
    'CW',
    'CY',
    'CZ',
    'DE',
    'DK',
    'DO',
    'EE',
    'EG',
    'ES',
    'FI',
    'FK',
    'FR',
    'GA',
    'GB',
    'GE',
    'GF',
    'GG',
    'GI',
    'GL',
    'GR',
    'HK',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IS',
    'IT',
    'JE',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KR',
    'KW',
    'KY',
    'KYG',
    'KZ',
    'LI',
    'LT',
    'LU',
    'LV',
    'MA',
    'MC',
    'ME',
    'MK',
    'MM',
    'MN',
    'MO',
    'MQ',
    'MT',
    'MU',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NG',
    'NL',
    'NO',
    'NZ',
    'PA',
    'PE',
    'PG',
    'PH',
    'PL',
    'PR',
    'PT',
    'QA',
    'RE',
    'RO',
    'RU',
    'SA',
    'SE',
    'SG',
    'SI',
    'SK',
    'SN',
    'SR',
    'TC',
    'TH',
    'TR',
    'TW',
    'TZ',
    'UA',
    'UK',
    'US',
    'UY',
    'VG',
    'VN',
    'XS',
    'ZA',
    'ZM'
];

export const currencyCodes: string[] = [
    'AED',
    'ARS',
    'AUD',
    'BRL',
    'CAD',
    'CHF',
    'CLP',
    'CNY',
    'COP',
    'CZK',
    'DKK',
    'EGP',
    'EUR',
    'GBp',
    'HKD',
    'HUF',
    'IDR',
    'ILA',
    'ILS',
    'INR',
    'ISK',
    'JPY',
    'KES',
    'KRW',
    'KWF',
    'KZT',
    'LBP',
    'MXN',
    'MYR',
    'NGN',
    'NOK',
    'NZD',
    'PLN',
    'QAR',
    'RON',
    'RUB',
    'SAR',
    'SEK',
    'SGD',
    'SOL',
    'THB',
    'TRY',
    'TWD',
    'USD',
    'VEZ',
    'VND',
    'ZAc',
    'ZAR'
];

export const sectors: string[] = [
    'Energy',
    'Materials',
    'Industrials',
    'Consumer Discretionary',
    'Consumer Staples',
    'Health Care',
    'Financials',
    'Information Technology',
    'Communication Services',
    'Utilities',
    'Real Estate',
    'Currencies',
    'Bonds'
];

export const industries: string[] = [
    'Energy Equipment & Services',
    'Oil, Gas & Consumable Fuels',
    'Chemicals',
    'Construction Materials',
    'Containers & Packaging',
    'Metals & Mining',
    'Paper & Forest Products',
    'Aerospace & Defense',
    'Building Products',
    'Construction & Engineering',
    'Electrical Equipment',
    'Industrial Conglomerates',
    'Industrial Conglomerates',
    'Trading Companies & Distributors',
    'Commercial Services & Supplies',
    'Professional Services',
    'Air Freight & Logistics',
    'Passenger Airlines',
    'Marine Transportation',
    'Ground Transportation',
    'Transportation Infrastructure',
    'Automobile Components',
    'Automobiles',
    'Household Durables',
    'Leisure Products',
    'Textiles, Apparel & Luxury Goods',
    'Hotels, Restaurants & Leisure',
    'Diversified Consumer Services',
    'Distributors',
    'Broadline Retail',
    'Specialty Retail',
    'Consumer Staples Distribution & Retail',
    'Beverages',
    'Food Products',
    'Tobacco',
    'Household Products',
    'Personal Care Products',
    'Health Care Equipment & Supplies',
    'Health Care Providers & Services',
    'Health Care Technology',
    'Biotechnology',
    'Pharmaceuticals',
    'Life Sciences Tools & Services',
    'Banks',
    'Financial Services',
    'Consumer Finance',
    'Capital Markets',
    'Mortgage Real Estate Investment Trusts (REITs)',
    'Insurance',
    'IT Services',
    'Software',
    'Communications Equipment',
    'Technology Hardware, Storage & Peripherals',
    'Electronic Equipment, Instruments & Components',
    'Semiconductors & Semiconductor Equipment',
    'Diversified Telecommunication Services',
    'Wireless Telecommunication Services',
    'Media',
    'Entertainment',
    'Interactive Media & Services',
    'Electric Utilities',
    'Gas Utilities',
    'Multi-Utilities',
    'Water Utilities',
    'Independent Power and Renewable Electricity Producers',
    'Diversified REITs',
    'Industrial REITs',
    'Hotel & Resort REITs',
    'Office REITs',
    'Health Care REITs',
    'Residential REITs',
    'Retail REITs',
    'Specialized REITs',
    'Real Estate Management & Development',
    'Cash Equivalent'
];
